import { computed } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3';
export default function useClients() {
    const { props: pageProps } = usePage();
    const examination = computed(() => pageProps.value.examination);
    const pagination = computed(() => pageProps.value.pagination);
    const schools = computed(() => pageProps.value.schools);
    const userId = computed(() => pageProps.value.userId);
    const name = computed(() => pageProps.value.name);
    const email = computed(() => pageProps.value.email);
    const school = computed(() => pageProps.value.school);
    const linkedStatus = computed(() => pageProps.value.linkedStatus);
    const isPurchase = computed(() => pageProps.value.isPurchase);
    const limit = computed(() => pageProps.value.limit);
    return {
        examination,
        pagination,
        schools,
        userId,
        name,
        email,
        school,
        linkedStatus,
        isPurchase,
        limit,
    };
}
